export const OVERALL_ALARM_ACTIONS = {
  GET_TAG_TREND_FAILURE: 'GET_TAG_TREND_FAILURE',
  GET_TAG_TREND_REQUEST: 'GET_TAG_TREND_REQUEST,',
  GET_TAG_TREND_SUCCESS: 'GET_TAG_TREND_SUCCESS',
};

export const BASE_GRAPH_OPTIONS = {
  LAST_DAYS: 'last_days',
  LAST_READINGS: 'last_measurements',
  BASELINE: 'from_baseline'
};

export const ALGO_OPTIONS = [
  { text: 'Multiplier', value: 'multiplier' },
  { text: 'Standard Deviation', value: 'standard_deviation' },
  { text: 'Offset', value: 'offset' },
];

export const DAYS_OPTIONS = [
  { text: '7 days', value: 7 },
  { text: '15 days', value: 15 },
  { text: '30 days', value: 30 }
];

export const READINGS_OPTIONS = [
  { text: '10 readings', value: 10 },
  { text: '20 readings', value: 20 },
  { text: '30 readings', value: 30 }
];

export const getAlgoOptions = t => [
  {
    text: t('assetHierarchy.overallAlarm.thresholdSettings.algoOptions.multiplier', { defaultValue: 'Multiplier' }),
    value: 'multiplier'
  },
  {
    text: t('assetHierarchy.overallAlarm.thresholdSettings.algoOptions.standardDeviation', {
      defaultValue: 'Standard Deviation'
    }),
    value: 'standard_deviation'
  },
  {
    text: t('assetHierarchy.overallAlarm.thresholdSettings.algoOptions.offset', { defaultValue: 'Offset' }),
    value: 'offset'
  },
];

export const getDaysOptions = t => DAYS_OPTIONS.map(({ value }) => ({
  text: t('assetHierarchy.overallAlarm.baseGraphSettings.daysOption', {
    count: value,
    defaultValue: `${value} days`
  }),
  value
}));

export const getReadingsOptions = t => READINGS_OPTIONS.map(({ value }) => ({
  text: t('assetHierarchy.overallAlarm.baseGraphSettings.readingsOption', {
    count: value,
    defaultValue: `${value} readings`
  }),
  value
}));

export const OVERALL_ALARM_STATES = {
  CREATE: 'create',
  EDIT: 'edit',
  RESET: 'reset',
  VIEW: 'view'
};

export const commonDefaultOverallAlarmSettings = {
  base_graph: {
    type: BASE_GRAPH_OPTIONS.LAST_DAYS,
    value: 30
  },
  threshold: {
    type: 'multiplier',
    warning_factor: 1.5,
    critical_factor: 2.5
  },
  lower_outlier_limit: null
};

export const ALARMS_ROUND_TO_NUMBER = 3;

// Each amplitude box deletes every measure of that amplitude: RMS, peak, p2p and narrowband.
export const DELETE_OVERALL_ALARM_OPTIONS = [
  {
    tKey: 'assetHierarchy.deleteOverallAlarms.options.allVelocityMeasures',
    defaultValue: 'Overall Alarms (all velocity measures)',
    value: 'velocity'
  },
  {
    tKey: 'assetHierarchy.deleteOverallAlarms.options.allAccelerationMeasures',
    defaultValue: 'Overall Alarms (all acceleration measures)',
    value: 'acceleration'
  },
  {
    tKey: 'assetHierarchy.deleteOverallAlarms.options.demod',
    defaultValue: 'Demod Alarms',
    value: 'demod'
  },
  {
    tKey: 'assetHierarchy.deleteOverallAlarms.options.temperature',
    defaultValue: 'Temperature',
    value: 'temperature'
  },
  {
    tKey: 'assetHierarchy.deleteOverallAlarms.options.others',
    defaultValue: 'Others',
    value: 'others'
  },
];
